module.exports = __webpack_public_path__ + "img/home-banner-2.93cf5e46.jpg";